import React from 'react';

import { Divider as StyledDivider } from './styles';

const Divider: React.FC<any> = (props) => <StyledDivider {...props} />;

export default Divider;
